import * as React from 'react';
import classNames from 'classnames';
import {
  Dialog as ReactAriaDialog,
  DialogProps as ReactAriaDialogProps,
  DialogTrigger as ReactAriaDialogTrigger,
  DialogTriggerProps as ReactAriaDialogTriggerProps,
} from 'react-aria-components';

import styles from './Dialog.module.css';

export interface DialogTriggerProps extends ReactAriaDialogTriggerProps {}
export interface DialogProps extends ReactAriaDialogProps {}

export function DialogTrigger(props: DialogTriggerProps) {
  return <ReactAriaDialogTrigger {...props} />;
}

export function Dialog({className, ...props}: DialogProps) {
  return <ReactAriaDialog className={classNames(className, styles.dialog)} {...props} />;
}
